<template>
  <q-checkbox
    :label="this.label || ''"
    class="checkbox"
    v-model="model"
    :size="this.small ? 'xs' : 'sm'"
    :disable="!!this.disable"
  />
</template>

<script>
export default {
  name: "CustomCheckbox",
  props: ["value", "label", "withNull", "withNullState", "binary", "small", "disable"],
  methods: {
    checkBinary(value, isBinary = false) {
      if (isBinary) {
        if (value === true)
          return 1
        else if (value === false)
          return 0
      }
      return value
    }
  },
  computed: {
    model: {
      get() {
        return this.binary ? this.value === null ? this.value : !!this.value : this.value;
      },
      set(newValue) {
        if (this.withNull) {
          let checkValue = ""
          if (this.value === null || this.value === '') {
            checkValue = true;
          } else if (this.value === true || this.value === 1) {
            checkValue = false;
          } else if (this.value === false || this.value === 0) {
            checkValue = null;
            if(this.withNullState) checkValue = true
          }
          return this.$emit("change", this.checkBinary(checkValue, this.binary));
        }
        this.$emit("change", this.checkBinary(newValue, this.binary));
      },
    },
  },
};
</script>

<style scoped lang="scss">
.checkbox {
  :deep(.q-checkbox__bg) {
    border-width: 1px !important;
  }
}
</style>
